module.exports = __webpack_public_path__ + "4dc73d7865dbf9e94db1e3f34d4b5b77.pdf";